import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import '../../styles/components/common/Drawer.css'

const Drawer = ({ title, onClose, children, className = '' }) => {
  const drawerRef = useRef(null)
  const previousFocusRef = useRef(null)
  const [visible, setVisible] = useState(false)
  const touchStartXRef = useRef(null)
  useEffect(() => {
    previousFocusRef.current = document.activeElement
    setVisible(true)
    if (drawerRef.current) {
      drawerRef.current.focus()
    }
    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        handleClose()
      } else if (e.key === 'Tab') {
        const focusableElements = drawerRef.current.querySelectorAll('a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])')
        if (focusableElements.length === 0) {
          e.preventDefault()
          return
        }
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]
        if (!e.shiftKey && document.activeElement === lastElement) {
          e.preventDefault()
          firstElement.focus()
        }
        if (e.shiftKey && document.activeElement === firstElement) {
          e.preventDefault()
          lastElement.focus()
        }
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])
  const handleTouchStart = e => {
    touchStartXRef.current = e.touches[0].clientX
  }
  const handleTouchMove = e => {
    if (!touchStartXRef.current) return
    const currentX = e.touches[0].clientX
    const diff = touchStartXRef.current - currentX
    if (diff > 50) {
      handleClose()
    }
  }
  const handleClose = () => {
    setVisible(false)
    setTimeout(() => {
      onClose && onClose()
      if (previousFocusRef.current && typeof previousFocusRef.current.focus === 'function') {
        previousFocusRef.current.focus()
      }
    }, 300)
  }
  return ReactDOM.createPortal(
    <div className={`drawer-overlay ${visible ? 'open' : 'closed'}`} onClick={handleClose}>
      <div
        className={`drawer ${visible ? 'open' : 'closed'} ${className}`}
        onClick={e => e.stopPropagation()}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        role="dialog"
        aria-modal="true"
        aria-labelledby="drawer-title"
        tabIndex="-1"
        ref={drawerRef}
      >
        <div className="drawer-live-announcement" aria-live="assertive" style={{position:'absolute', width:'1px', height:'1px', overflow:'hidden', clip:'rect(1px, 1px, 1px, 1px)'}}>Drawer opened</div>
        <div className="drawer-header">
          <h2 id="drawer-title" className="drawer-title">{title}</h2>
          <button className="drawer-close-button" onClick={handleClose} aria-label="Close drawer">&times;</button>
        </div>
        <div className="drawer-content">{children}</div>
      </div>
    </div>,
    document.body
  )
}

export default Drawer
